import { useHistory, useParams } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { Button, InputItem, List, Modal, Toast, WhiteSpace } from "antd-mobile";
import instance from "../../../../util/axios";
import { Result } from "../../../../schema";
import DictionarySelect from "../../../../component/CheckBoxItem";
import "../main.css";
import moment from "moment";
import AgainList from "./components/AgainList";
import { workerData } from "worker_threads";
import { setFlagsFromString } from "v8";

export default function CompletionListAgain() {
  const history = useHistory();
  const params = useParams<{
    fillingId: string;
  }>();
  const CompletionListRef = useRef<any>();
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [dialogForm, setDialogForm] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  const [homeParams, setHomeParams] = useState<{
    isReturning: string;
    isOther?: string;
    workshopId?: string;
    procedureId?: string;
    remarkId?: string;
    staffId?: string;
    orderCalType?: string;
    useGroup?: string;
    groupId?: string;
    joinedStaffsId?: string;
    workDate?: string;
    submitId?: string;
  }>({
    isReturning: "2",
  });
  const [proId, setProId] = useState<string>("");
  const [isCutting, setIsCutting] = useState<boolean>(false);
  const [submitForm, setSubmitForm] = useState<{
    visible: boolean;
    skuId?: string;
    userId?: string;
    staffId?: string;
    skuName?: string;
    formulaName?: string;
    departmentIds?: string;
    procedureIds?: string;
    procedureId?: string;
    psiId?: string;
    psiName?: string;
    specs?: string;
    workshopId?: string;
    remarkId?: string;
    workflowId?: string;
    orderDetailId?: string;
    orderTime?: string;
    isMultiple?: string;
    orderNo?: string;
    quantity?: string;
    pieces?: string;
    joinedStaffsId?: string;
    orderCalType?: string;
    selectedCount?: string;
    isReturning?: string;
    isOther?: string;
    status?: string;
  }>({
    visible: false,
  });
  useEffect(() => {
    if (params?.fillingId) {
      instance
        .post(
          `/erp/sku/workshop/getCompletionFillingList?fillingId=${params?.fillingId}`
        )
        .then((resp) => {
          if (resp?.data?.Status === "1") {
            const data = resp?.data?.Data?.data?.[0];
            setProId(data?.procedureId);
            setHomeParams({
              isReturning: data?.completions?.[0]?.isReturning || "2",
              isOther: data?.isOther,
              workshopId: data?.workshopId,
              procedureId: data?.procedureId,
              remarkId: data?.remarkId,
              staffId: data?.staffId,
              orderCalType: data?.orderCalType,
              useGroup: data?.useGroup,
              groupId: data?.groupId,
              joinedStaffsId: data?.joinedStaffsId,
              submitId: data?.submitId,
            });
            setSubmitForm((prev) => ({
              ...prev,
              procedureId: data?.procedureId,
              staffId: data?.staffId,
              orderCalType: data?.orderCalType,
              joinedStaffsId: data?.joinedStaffsId,
              isReturning: data?.isReturning,
              isOther: data?.isOther,
              remarkId: data?.remarkId,
              submitId: data?.submitId,
            }));
            let baseConfigValue = "";
            instance
              .post(`oa/base/phone/getBaseConfig`, {
                name: "下料工序",
              })
              .then((resp) => {
                if (resp.data.Status === "1") {
                  baseConfigValue = resp.data.Data?.value;
                  if (baseConfigValue.includes(data?.procedureId!)) {
                    setIsCutting(true);
                  }
                }
              });
          }
        });
    }
  }, [params?.fillingId]);
  const descriptionCutting = [
    {
      fieldName: "completeTime",
      fieldShowName: "计划完成时间",
      width: 120,
    },
    {
      fieldName: "orderNo",
      fieldShowName: "批号",
      width: 120,
    },
    {
      fieldName: "skuName",
      fieldShowName: "产品",
      width: 120,
    },
    {
      fieldName: "allotQuantity",
      fieldShowName: "商品分配数量",
      width: 120,
    },
    {
      fieldName: "code",
      fieldShowName: "物料编码",
      width: 120,
    },
    {
      fieldName: "psiName",
      fieldShowName: "物料名称",
      inputType: 0,
      width: 120,
    },
    {
      fieldName: "length",
      fieldShowName: "长度",
      width: 120,
    },

    {
      fieldName: "bomTotalQuantity",
      fieldShowName: "所需下料数量",
      width: 120,
    },
    {
      fieldName: "practicalLength",
      fieldShowName: "实际下料长度",
      width: 120,
    },
    {
      fieldName: "practicalQuantity",
      fieldShowName: "实际下料数量",
      width: 120,
    },
    {
      fieldName: "outQuantity",
      fieldShowName: "已下料数量",
      width: 120,
    },
    {
      fieldName: "noOutQuantity",
      fieldShowName: "未下料数量",
      width: 120,
    },
  ];

  const descriptionNoCutting = [
    {
      fieldName: "orderTime",
      fieldShowName: "计划完成时间",
      width: 120,
    },
    {
      fieldName: "orderNo",
      fieldShowName: "批号",
      width: 120,
    },
    {
      fieldName: "dealerName",
      fieldShowName: "客户名称",
      width: 120,
    },
    {
      fieldName: "skuName",
      fieldShowName: "产品",
      width: 120,
    },
    {
      fieldName: "gear",
      fieldShowName: "排档方式",
      width: 120,
    },
    {
      fieldName: "gearModel",
      fieldShowName: "主管/档管规格",
      width: 120,
    },
    {
      fieldName: "color",
      fieldShowName: "表面处理",
      width: 120,
      inputType: 6,
      dictionary: "dict_rad_color",
    },
    {
      fieldName: "formulaName",
      fieldShowName: "图号",
      width: 120,
    },
    {
      fieldName: "length",
      fieldShowName: "长度",
      width: 120,
    },
    {
      fieldName: "totalQuantities",
      fieldShowName: "组数",
      width: 120,
    },
    {
      fieldName: "completionQuantity",
      fieldShowName: "已完成组数",
      width: 120,
    },
    {
      fieldName: "totalPieces",
      fieldShowName: "柱/档数",
      width: 120,
    },
    {
      fieldName: "completionPieces",
      fieldShowName: "已完成柱/档数",
      width: 120,
    },
  ];

  const getData = (homeParams: any) => {
    let arr: any = [];
    let onSelectRows = CompletionListRef.current.getCheckedItem();
    onSelectRows.forEach(
    // selectedRows.forEach(
      (item: {
        quantity: string;
        pieces: string;
        length: string;
        totalQuantities: string;
        totalPieces: string;
        isMultiple: string;
        psiId: string;
        psiName: string;
        specs: string;
        userId: string;
        isFilled: any;
        uuid: any;
        skuId: any;
        blankingId: any;
        skuName: any;
        formulaName: any;
        orderNo: any;
        practicalQuantity: any;
        practicalLength: any;
        bomTotalQuantity: any;
        completeTime: any;
        ref: { workshopId: any };
        orderDetailId: any;
        orderTime: any;
        workflowId: any;
        staffId: any;
        isReturning: any;
        isOther: any;
        remarkId: any;
        procedureId: any;
        orderCalType: any;
        joinedStaffsId: any;
        fillingId: any;
        workDate: any;
        submitId: any;
      }) => {
        arr.push({
          uuid: item.uuid,
          skuId: item.skuId,
          blankingId: item.blankingId,
          skuName: item.skuName,
          formulaName: item.formulaName,
          length: item.length || "",
          psiId: item.psiId || "",
          psiName: item.psiName || "",
          specs: item.specs || "",
          isMultiple: item.isMultiple,
          isReturning: homeParams?.isReturning,
          orderNo: item.orderNo,
          workshopId: item.ref.workshopId,
          orderDetailId: item.orderDetailId,
          orderTime: isCutting
            ? moment(item.completeTime, "YYYY-MM-DD HH:mm:ss").format(
                "YYYY-MM-DD"
              )
            : item.orderTime,
          workflowId: item.workflowId,
          quantity: item?.isFilled != "1" ? item.quantity || "0" : "0",
          piecesQuantity: item?.isFilled != "1" ? item.pieces || "0" : "0",
          totalQuantities: item.totalQuantities || "0",
          totalPieces: item.totalPieces || "0",
          practicalQuantity: item.practicalQuantity || "0",
          practicalLength: item.practicalLength || "0",
          bomTotalQuantity: item.bomTotalQuantity || "0",
          fillingId: item.fillingId,
          workerData: item.workDate,
          submitId: item?.submitId,
        });
      }
    );
    let completionListJson = {
      isReturning: homeParams?.isReturning,
      isOther: homeParams?.isOther,
      workshopId: homeParams?.workshopId,
      procedureId: homeParams?.procedureId,
      remarkId: homeParams?.remarkId,
      staffId: homeParams?.staffId,
      orderCalType: homeParams?.orderCalType,
      useGroup: homeParams?.useGroup,
      groupId: homeParams?.groupId,
      joinedStaffsId: homeParams?.joinedStaffsId,
      fillingId: homeParams?.fillingId,
      completionList: arr,
      submitId: homeParams?.submitId,
      workDate: homeParams?.workDate,
    };
    return completionListJson;
  };

  const onSave = async (status: string) => {
    let onSelectRows = CompletionListRef.current.getCheckedItem();
    console.log(22222);
    console.log(onSelectRows);
    setSelectedRows(onSelectRows);
    let obj = CompletionListRef.current.getcompletionHome();
    let emptyFlag = false;
    let errorFlag = false;
    let overFlag = false;
    let overCuttingFlag = false;
    onSelectRows.forEach((item: any) => {
      if (
        (item.quantity === undefined || item.quantity === "") &&
        (item.pieces === undefined || item.pieces === "")
      ) {
        emptyFlag = true;
      }
      if (item.quantity && item.pieces) {
        errorFlag = true;
      }
      if (homeParams.isReturning === "2") {
        const alreadyQuantity =
          parseInt(item.completionQuantity || "0") +
          parseInt(item.quantity || "0");
        const alreadyPieces =
          parseInt(item.completionPieces || "0") + parseInt(item.pieces || "0");
        if (
          alreadyQuantity > parseInt(item.totalQuantities) ||
          alreadyPieces > parseInt(item.totalPieces)
        ) {
          overFlag = true;
        }
      }
      if (isCutting) {
        const alreadyQuantity =
          parseInt(item.quantity || "0") + parseInt(item.outQuantity || "0");
        if (alreadyQuantity > parseInt(item.practicalQuantity)) {
          overCuttingFlag = true;
        }
      }
    });
    if (emptyFlag) {
      Toast.fail("您选中的订单未填写本次组数或本次柱/档数！");
      return;
    }
    if (errorFlag) {
      Toast.fail("本次组数 和 本次柱/档数只能填写一项，请检查！");
      return;
    }
    if (overFlag) {
      Toast.fail(
        "您选中的订单本次组数超过总组数或者本次柱/档数超过总柱/档数！"
      );
      return;
    }
    if (overCuttingFlag) {
      Toast.fail("您选中的订单本次下料数量超过可填写数量！");
      return;
    }
    const param = {
      isReturning: obj?.isReturning,
      isOther: obj?.isOther,
      workshopId: obj?.workshopId,
      procedureId: obj?.procedureId,
      remarkId: obj?.remarkId,
      staffId: obj?.staffId,
      orderCalType: obj?.orderCalType,
      useGroup: obj?.useGroup,
      groupId: obj?.groupId,
      joinedStaffsId: obj?.joinedStaffsId,
      fillingId: obj?.fillingId,
      workDate: obj?.workDate,
      submitId: obj?.submitId,
    };
    setHomeParams(param);
    setProId(obj?.procedureId);

    if(param.procedureId === undefined || param.procedureId === "") {
      Toast.fail("请填写要填报的工序！");
      return;
    }
    if(param.remarkId === undefined || param.remarkId === "") {
      Toast.fail("请填写要填报的生产产品！");
      return;
    }
    if(param.staffId === undefined || param.staffId === "") {
      Toast.fail("请填写要填报的员工！");
      return;
    }
    if(param.orderCalType === undefined || param.orderCalType === "") {
      Toast.fail("请填写要填报的类型！");
      return;
    }
    if(param.workDate === undefined || param.workDate === "") {
      Toast.fail("请填写要工作日期！");
      return;
    }
    if(param.orderCalType === "2" && !param.joinedStaffsId) {
       Toast.fail("集体计件请选择参与员工！");
       return;
    }

    if (status === "save") {
      const data = getData(param);
      console.log(selectedRows);
      console.log(999);
      const resp = await instance.post<Result<string>>(
        `/erp/sku/workshop/insertCompletionList`,
        {
          completionListJson: JSON.stringify(data),
          status: status,
        }
      );
      if (resp.data.Status === "1") {
        Toast.success(`操作成功！`);
      }

      instance
        .post(
          `/erp/sku/workshop/getCompletionFillingList?fillingId=${params?.fillingId}`
        )
        .then((resp) => {
          if (resp?.data?.Status === "1") {
            const data = resp?.data?.Data?.data?.[0];
            setProId(data?.procedureId);
            setHomeParams({
              isReturning: data?.completions?.[0]?.isReturning || "2",
              isOther: data?.isOther,
              workshopId: data?.workshopId,
              procedureId: data?.procedureId,
              remarkId: data?.remarkId,
              staffId: data?.staffId,
              orderCalType: data?.orderCalType,
              useGroup: data?.useGroup,
              groupId: data?.groupId,
              joinedStaffsId: data?.joinedStaffsId,
              workDate: data?.workDate,
              submitId: data?.submitId,
            });
          }
        }); 


    } else {
      setSubmitForm((prev) => ({
        ...prev,
        visible: true,
        procedureId: obj?.procedureId,
        staffId: obj?.staffId,
        orderCalType: obj?.orderCalType,
        joinedStaffsId: obj?.joinedStaffsId,
        selectedCount: onSelectRows.length,
        status: status,
      }));
    }
  };

  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div style={{ flex: 1, overflowY: "auto" }}>
          <AgainList
            url={`/erp/sku/workshop/getCompletionFillingList?fillingId=${params?.fillingId}&procedureId=${proId}&st=1`}
            ref={CompletionListRef}
            descriptions={isCutting ? descriptionCutting : descriptionNoCutting}
            homeParams={homeParams}
            isCutting={isCutting}
            getProId={(id: any) => {
              setProId(id);
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            background: "#fff",
          }}
        >
          <Button
            style={{ width: "30%", zIndex: 99 }}
            onClick={() => onSave("save")}
          >
            保存
          </Button>
          <Button
            type="primary"
            style={{ width: "30%", zIndex: 99 }}
            onClick={() => onSave("submit")}
          >
            提交
          </Button>
          <Button
            style={{ width: "30%", zIndex: 99 }}
            type="primary"
            onClick={() => {
              history.go(-1);
              CompletionListRef.current.clearCheckedItem();
            }}
          >
            返回
          </Button>
        </div>
      </div>
      <Modal
        title={"工量填报"}
        visible={submitForm.visible}
        onClose={() => {
          setSubmitForm((prev) => ({
            ...prev,
            visible: false,
          }));
        }}
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "取消",
            onPress: () => {
              setSubmitForm((prev) => ({
                ...prev,
                visible: false,
              }));
            },
          },
          {
            text: "提交",
            onPress: async () => {
              setSubmitForm((prevState) => ({
                ...prevState,
                visible: false,
              }));
              setDialogForm({
                visible: true,
              });
            },
          },
        ]}
      >
        <List>
          <DictionarySelect
            title={"工序"}
            multiple={false}
            dictionary={"erp_procedure"}
            value={submitForm.procedureId}
            disabled={true}
          />
        </List>
        <List>
          <DictionarySelect
            title={"员工"}
            multiple={false}
            disabled={true}
            dictionary={"base_staff"}
            value={submitForm.staffId}
          />
        </List>
        <List>
          <DictionarySelect
            title={"类型"}
            multiple={false}
            disabled={true}
            dictionary={"dict_order_production_cal_type"}
            value={submitForm.orderCalType}
          />
        </List>
        <List>
          <DictionarySelect
            title={"参与员工"}
            multiple={true}
            disabled={true}
            dictionary={"base_staff"}
            value={submitForm.joinedStaffsId}
          />
        </List>
        <List>
          <InputItem type={"text"} value={submitForm.selectedCount} disabled>
            已选产品
          </InputItem>
        </List>
      </Modal>
      <Modal
        title={"确认"}
        visible={dialogForm.visible}
        onClose={() => {
          setDialogForm({
            visible: false,
          });
        }}
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "取消",
            onPress: () => {
              setDialogForm({
                visible: false,
              });
            },
          },
          {
            text: "确定",
            onPress: async () => {
              //let onSelectRows = CompletionListRef.current.getCheckedItem();
              let arr: any = [];
              console.log(1111);
              console.log(selectedRows);
              selectedRows.forEach(
                (item: {
                  quantity: string;
                  pieces: string;
                  length: string;
                  totalQuantities: string;
                  totalPieces: string;
                  isMultiple: string;
                  psiId: string;
                  psiName: string;
                  specs: string;
                  userId: string;
                  isFilled: any;
                  uuid: any;
                  skuId: any;
                  blankingId: any;
                  skuName: any;
                  formulaName: any;
                  orderNo: any;
                  practicalQuantity: any;
                  practicalLength: any;
                  bomTotalQuantity: any;
                  completeTime: any;
                  ref: { workshopId: any };
                  orderDetailId: any;
                  orderTime: any;
                  workflowId: any;
                  staffId: any;
                  isReturning: any;
                  isOther: any;
                  remarkId: any;
                  procedureId: any;
                  orderCalType: any;
                  joinedStaffsId: any;
                  fillingId : any;
                  submitId: any;
                }) => {
                  arr.push({
                    uuid: item.uuid,
                    skuId: item.skuId,
                    blankingId: item.blankingId,
                    skuName: item.skuName,
                    formulaName: item.formulaName,
                    length: item.length || "",
                    psiId: item.psiId || "",
                    psiName: item.psiName || "",
                    specs: item.specs || "",
                    isMultiple: item.isMultiple,
                    isReturning: homeParams?.isReturning,
                    orderNo: item.orderNo,
                    workshopId: item.ref.workshopId,
                    orderDetailId: item.orderDetailId,
                    orderTime: isCutting
                      ? moment(item.completeTime, "YYYY-MM-DD HH:mm:ss").format(
                          "YYYY-MM-DD"
                        )
                      : item.orderTime,
                    workflowId: item.workflowId,
                    quantity:
                      item?.isFilled != "1" ? item.quantity || "0" : "0",
                    piecesQuantity:
                      item?.isFilled != "1" ? item.pieces || "0" : "0",
                    totalQuantities: item.totalQuantities || "0",
                    totalPieces: item.totalPieces || "0",
                    practicalQuantity: item.practicalQuantity || "0",
                    practicalLength: item.practicalLength || "0",
                    bomTotalQuantity: item.bomTotalQuantity || "0",
                    fillingId: item.fillingId,
                    submitId: item.submitId,
                  });
                }
              );
              let completionListJson = {
                isReturning: homeParams?.isReturning,
                isOther: homeParams?.isOther,
                workshopId: homeParams?.workshopId,
                procedureId: homeParams?.procedureId,
                remarkId: homeParams?.remarkId,
                staffId: homeParams?.staffId,
                orderCalType: homeParams?.orderCalType,
                useGroup: homeParams?.useGroup,
                groupId: homeParams?.groupId,
                joinedStaffsId: homeParams?.joinedStaffsId,
                completionList: arr,
                workDate: homeParams?.workDate,
                submitId: homeParams?.submitId,
              };
              const resp = await instance.post<Result<string>>(
                `/erp/sku/workshop/insertCompletionList`,
                {
                  completionListJson: JSON.stringify(completionListJson),
                  status: submitForm.status,
                }
              );
              if (resp.data.Status === "1") {
                Toast.success(`操作成功！`);
                debugger;
                if (isCutting) {
                  var ids = resp.data.Data.split(",");
                  for (let i = 0; i < ids.length; i++) {
                    instance
                      .post("/wf/form/vsheet/submit", {
                        id: ids[i],
                        name: "手机领料单",
                      })
                      .then((data) => {
                        if (data.data.Status === "1") {
                          history.go(-1);
                        } else {
                          Toast.fail(
                            "手机领料单自动提交审核失败！失败原因：" +
                              data.data.Data
                          );
                        }
                      });
                  }
                } else {
                  history.go(-1);
                }
              } else {
                Toast.fail(resp.data.Data);
              }
              setDialogForm({
                visible: false,
              });
              setSubmitForm({
                visible: false,
              });
            },
          },
        ]}
      >
        <p style={{ fontSize: "20px" }}>确认提交本次完成数量吗？</p>
      </Modal>
    </>
  );
}
